/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect } from 'react';

import { ActiveGamesUpdateDocument, useActiveGamesQuery } from './gql/hooks';

const ActiveGamesSubscribe = () => {
  const { data, loading, error, subscribeToMore } = useActiveGamesQuery({
    ssr: false
  });

  useEffect(() => {
    const unsubscribe = subscribeToMore({
      document: ActiveGamesUpdateDocument,
      updateQuery: (prev, { subscriptionData }) => ({
        ...prev
      })
    });

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [subscribeToMore]);

  return '';
};

export default ActiveGamesSubscribe;
